import { readUserGroupsFromStorage } from "utils/groupPolicyEngine";
import { canViewRouteWithSecApps } from "utils/secAppAccess";

/**
 * Group descriptions from signed-in user storage (legacy sidenav role checks).
 * @returns {string[]}
 */
export function readUserRolesFromStorage() {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const groups = user?.groups || [];
    return groups.map((g) => g?.description).filter(Boolean);
  } catch {
    return [];
  }
}

/**
 * Whether a sidenav/help route entry is visible for the current user.
 * Primary: allowedPolicy / allowedRoles. Secondary: sec_groups_apps route access.
 *
 * @param {{ allowedPolicy?: string, allowedRoles?: string[], hidden?: boolean, route?: string, secAppName?: string }|null|undefined} route
 * @param {{ userGroups?: Array, userRoles?: string[], restrictedSecApps?: string[], userAllowedSecApps?: string[] }} [context]
 * @returns {boolean}
 */
export function canViewRoute(route, context = {}) {
  return canViewRouteWithSecApps(route, {
    userGroups: context.userGroups ?? readUserGroupsFromStorage(),
    userRoles: context.userRoles ?? readUserRolesFromStorage(),
    restrictedSecApps: context.restrictedSecApps ?? [],
    userAllowedSecApps: context.userAllowedSecApps ?? [],
    userDeniedSecApps: context.userDeniedSecApps ?? [],
  });
}
